import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
export { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"; 
import { componentToRx } from "app/logic/rx";

import { CajaTurnoList } from "./cajas/list";
import { observeResource } from "kea-resource";
import { createSelectorRx } from "keautils";

type Entity = models.NuevoTurnoModel;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

const CargarCajasButton = kea.defaultProps(kea.Button, { children: "Cargas cajas del turno anterior" });

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdSucursal: validation.required,
        IdUsuario: validation.required,
        CajaTurnos: validation.required
    }
}

/**
* Componente para editar un Entity
*/
class TurnoFormNoRx extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
    }

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    onCargarCajasUltimoTurno = async () => {
        const value = this.props.value;
        const idUsuario = value.IdUsuario;
        if (!idUsuario) {
            kea.message("Seleccione un usuario primero");
            return;
        }

        const ultimoTurno = await resources.Turno.UltimoTurno(idUsuario);
        const nextValue: Entity = {
            ...value,
            CajaTurnos: ultimoTurno.CajaTurnos
        };

        this.props.onChange(nextValue);
    }

    idUsuario = (x: Props) => x.value.IdUsuario;

    usuarios = (props: Props) => observeResource(resources.Usuario.query, {});

    clientesFinales = createSelectorRx(this.idUsuario, idCliente => observeResource(resources.Usuario.getMemo, idCliente));


    idSucursal = (props: Props) => props.value.IdSucursal;
    usuariosFiltrados2 = createSelectorRx(this.usuarios, this.idSucursal, (usuarios, idSucursal) => usuarios.filter(x => x.IdSucursal == idSucursal));


    usuariosFiltrados =   createSelectorRx(this.usuarios, this.clientesFinales, this.idSucursal, (usuarios,GetUser, idSucursal) =>  
    {
        debugger
        if(GetUser.CrearTurnoDiferenteSucursal)
        { return usuarios.filter(x => x)}
        else
        { return usuarios.filter(x => x.IdSucursal == idSucursal)}
    });




    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;
        const Usuario = getField(selectores.Usuario);
        const CajaTurno = getField(CajaTurnoList);
        const Caja = getField(selectores.Caja);
        const Sucursal = getField(selectores.Sucursal);

        return (
            <div>
                <kea.Title titulo="Iniciar turno" onRegresar={() => history.go("../")} >
                    <CargarCajasButton onClick={this.onCargarCajasUltimoTurno} />
                </kea.Title>
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Usuario field="IdUsuario" label="Usuario" items={ this.usuariosFiltrados(this.props)} />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        {

                            value.IdSucursal ?
                                <CajaTurno field="CajaTurnos" idSucursal={value.IdSucursal} /> :
                                <div className="alert alert-warning">
                                    Seleccione la sucursal para asignar las cajas
                                </div>
                        }
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const TurnoForm = componentToRx(TurnoFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/turnos/edit/form.tsx